export default [
  {
    path: "/public/torneos/:slug",
    name: "public-torneo",
    component: () => import("@/views/public/torneos/PublicTournamentView.vue"),
    props: true,
  },
  {
    path: "/public/torneos/:slug/inscribirse",
    name: "public-torneo-inscribirse",
    component: () => import("@/views/public/torneos/PublicRegisterView.vue"),
    props: true,
  },
  {
    path: "/torneos/:slug/inscribir-pupilos",
    name: "torneo-inscribir-pupilos",
    component: () => import("@/views/public/torneos/PupilRegisterView.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
];
